export default "__VITE_PUBLIC_ASSET__fe0d41a4__"